import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	format: {
		id: 'business-conditional-formatting-sidebar.format-rules-sidebar.format',
		defaultMessage: 'Format',
		description: 'Heading of the format rules sidebar',
	},
});
